import { Box, Stack, Typography } from "@mui/material";

// Default strings that can be overridden
const DEFAULT_STRINGS = {
  JOIN_PRIVATE: "Request to join this event to see schedules, activities, and more.",
  JOIN_PUBLIC: "Join this event to see schedules, activities, and more.",
  JOIN_TITLE: "Join Event to View Details",
} as const;

interface BlurOverlayProps {
  children: React.ReactNode;
  showOverlayText?: boolean;
  isPublic?: boolean;
  isMember: boolean;
  overlayStrings?: {
    joinPrivate?: string;
    joinPublic?: string;
    joinTitle?: string;
  };
}

export const BlurOverlay = ({
  children,
  showOverlayText = false,
  isPublic = true,
  isMember,
  overlayStrings = {},
}: BlurOverlayProps) => {
  const strings = {
    ...DEFAULT_STRINGS,
    ...overlayStrings,
  };

  if (isMember) {
    return <>{children}</>;
  }

  return (
    <Box sx={{ position: "relative" }}>
      <Box
        data-testid="blur-box"
        sx={{
          filter: "blur(4px)",
          opacity: 0.6,
          pointerEvents: "none",
          userSelect: "none",
        }}
      >
        {children}
      </Box>
      {showOverlayText && (
        <Stack
          alignItems="center"
          justifyContent="center"
          spacing={1}
          sx={{
            backgroundColor: "rgba(255, 255, 255, 0.9)",
            borderRadius: 2,
            left: "50%",
            p: 3,
            position: "absolute",
            textAlign: "center",
            top: "50%",
            transform: "translate(-50%, -50%)",
            width: "80%",
            zIndex: 1,
          }}
        >
          <Typography variant="h6" data-testid="overlay-title">
            {strings.joinTitle}
          </Typography>
          <Typography variant="body2" color="text.secondary" data-testid="overlay-message">
            {isPublic ? strings.joinPublic : strings.joinPrivate}
          </Typography>
        </Stack>
      )}
    </Box>
  );
};
